const Contact=()=>{
  return (
    <div style={{display:'flex',width:'100%',height:`100%`}}>
      <div style={{display:'flex',height:window.innerHeight*window.barSize}}>
        İLETİŞİM
      </div>
      <div style={{display:'flex',width:'100%',height:window.innerHeight*(1-window.barSize*2),justifyContent:'space-evenly'}}>
        <div style={{display:'flex',justifyContent:'space-evenly',height:'50%'}}>
          <div style={{}}>
            <div style={{}}>
              ADRES
            </div>
            <div style={{fontFamily:'Helvetica',color:'silver'}}>
              Beyhekim Mahallesi / Ali Demirtaş Sokak / DK:94-2 <br/> Selçuklu Konya
            </div>
          </div>
          <div style={{}}>
            <div style={{}}>
              TELEFON
            </div>
            <div style={{}}>
              <a
              style={{fontFamily:'Helvetica',color:'silver'}}
              href="tel:+905073897124">+90 (507) 389 71 24</a>
            </div>
          </div>
          <div style={{}}>
            <div style={{}}>
              EMAIL
            </div>
            <div style={{}}>
            <a
            style={{fontFamily:'Helvetica',color:'silver'}}
            href="mailto:mstfaerken@gmail.com">mstfaerken@gmail.com</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Contact;
